import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { toastrError } from '@portals/redux/actions/toastr';
import { AuthType } from '@portals/types';

import { ORGANIZATIONS_API_URL } from './organizations.constants';
import { ServerError } from '../../types';
import { fetchApiRequest, useRequestOptions } from '../../utils';

export interface UseCreateOrganizationParams {
  org?: string;
  name?: string;
  email?: string;
  password?: string;
  accepted_terms_and_conditions?: boolean;
  afterAuthPath?: string;
  referral?: string | null;
  force_domain?: boolean;
}

export function useCreateOrganization() {
  const dispatch = useDispatch();
  const { url, options } = useRequestOptions({
    url: ORGANIZATIONS_API_URL,
    method: 'POST',
  });

  return useMutation<AuthType, ServerError, UseCreateOrganizationParams>({
    mutationFn: ({ afterAuthPath, ...params }) => {
      return fetchApiRequest(url, {
        ...options,
        body: JSON.stringify(params),
      });
    },
    onError: ({ error }) => {
      dispatch(toastrError(error));
    },
  });
}

interface UseCheckOrganizationExistenseProps {
  email: string;
}

interface CheckOrganizationExistenseResponse {
  in_use: boolean;
}

export function useCheckOrganizationExistense() {
  const dispatch = useDispatch();
  const { url, options } = useRequestOptions({
    url: `${ORGANIZATIONS_API_URL}/check_domain`,
    method: 'POST',
  });

  return useMutation<
    CheckOrganizationExistenseResponse,
    ServerError,
    UseCheckOrganizationExistenseProps
  >({
    mutationFn: (params) => {
      return fetchApiRequest(url, {
        ...options,
        body: JSON.stringify(params),
      });
    },
    onError: ({ error }) => {
      dispatch(toastrError(error));
    },
  });
}
